import styled from 'styled-components';

const Column = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  border-right: 1px solid ${({ theme }) => theme.colors.platinum};
  width: 100%;
  min-height: 30px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const Container = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
  padding-top: ${({ theme }) => theme.spacing(6)};
  position: relative;
  > ${Column}:last-child {
    border-right: none;
  }
`;

const Label = styled.span`
  ${({ theme }) => theme.fontFamily.secondaryFont.xSmallRegular};
  color: ${({ theme }) => theme.colors.night_blue_2};
  line-height: 1.33;
`;

const Loading = styled.span`
  &:after {
    content: '-';
  }
`;

const Text = styled.span`
  ${({ theme }) => theme.fontFamily.secondaryFont.xSmallBold}
  line-height: 1.5;
`;

export { Column, Row, Container, Label, Loading, Text };
